import { CartUpdateEvent } from '@theme/events';

/**
 * Swaps a cart line's subscription frequency in place.
 *
 * `/cart/change.js` accepts `selling_plan` alongside the line key, so this is a
 * single call — no remove-and-re-add, and the line keeps its position and
 * quantity. Only frequencies within the line's own plan group are offered, so
 * this can't move a line off a subscription.
 */
document.addEventListener('change', (event) => {
  const select = /** @type {HTMLSelectElement|null} */ (event.target?.closest('.cart-items__selling-plan-select'));
  if (!select) return;

  const sellingPlanId = parseInt(select.value, 10);
  const itemKey = select.dataset.itemKey;
  if (!sellingPlanId || !itemKey) return;

  const previousPlanId = select.dataset.currentPlan;
  const row = select.closest('tr[data-key]');

  select.disabled = true;
  row?.classList.add('cart-items-disabled');

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
    .map((el) => /** @type {HTMLElement} */ (el).dataset.sectionId)
    .filter(Boolean);

  /** @type {Record<string, string|number>} */
  const body = { id: itemKey, selling_plan: sellingPlanId };
  if (sectionIds.length) {
    body.sections = sectionIds.join(',');
    body.sections_url = window.location.pathname;
  }

  fetch(Theme.routes.cart_change_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Cart change failed: ${response.status}`);
      return response.json();
    })
    .then((data) => {
      if (data.status) throw new Error(data.description || data.message);

      select.dataset.currentPlan = String(sellingPlanId);
      document.dispatchEvent(
        new CartUpdateEvent(data, 'cart-selling-plan', {
          source: 'cart-selling-plan',
          itemCount: data.item_count,
          sections: data.sections,
        })
      );
    })
    .catch((error) => {
      console.error('Cart selling plan change error:', error);
      // The re-render never happened, so put the row back the way the customer
      // found it rather than leaving it showing a frequency they aren't on.
      if (previousPlanId) select.value = previousPlanId;
      select.disabled = false;
      row?.classList.remove('cart-items-disabled');
    });
});
